import useActivityAcknowledgementContext from '/druid/private/useContext';

export default function useMarkActivityKeyAsRead(): (activityKey: string) => void {
  return useActivityAcknowledgementContext().markActivityKeyAsRead;
}
